module.exports = __webpack_public_path__ + "img/usa.dc797c10.svg";